// Сдвиг в операторе TJ (в тысячных долях кегля), начиная с которого считаем,
// что между глифами межсловный пробел (обычная ширина пробела ~250-300,
// кернинг внутри слова заметно меньше)
const PDF_WORD_GAP_THRESHOLD = 150

export const loadPdfjs = async () => {
  const module = await import('@bundled-es-modules/pdfjs-dist/build/pdf')
  // Бандл @bundled-es-modules отдаёт библиотеку только через default-экспорт
  const pdfjs = module.default || module

  // Без workerSrc pdf.js 2.x не может поднять worker и getDocument падает.
  // Используем тот же CDN, что и @mikecousins/react-pdf по умолчанию
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  }

  return pdfjs
}

const fileToUint8Array = async (file) => {
  if (typeof file?.arrayBuffer === 'function') {
    return new Uint8Array(await file.arrayBuffer())
  }

  // Fallback для старых браузеров без Blob.arrayBuffer()
  return new Uint8Array(await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(file)
  }))
}

// getTextContent() в pdf.js 2.2 теряет пробелы, заданные в TJ только сдвигом
// без глифа пробела (типично для PDF из ONLYOFFICE), поэтому для проверки слов
// восстанавливаем текст страницы из списка операторов с учётом сдвигов
const readPageTextFromOperators = async (pdfjs, page) => {
  const operatorList = await page.getOperatorList()
  const parts = []

  operatorList.fnArray.forEach((fn, index) => {
    if (fn !== pdfjs.OPS.showText) return

    const glyphs = operatorList.argsArray[index]?.[0]
    if (!Array.isArray(glyphs)) return

    let text = ''

    glyphs.forEach((glyph) => {
      if (typeof glyph === 'number') {
        // Отрицательный сдвиг двигает текст вперёд — трактуем как пробел
        if (glyph < -PDF_WORD_GAP_THRESHOLD) text += ' '
        return
      }

      if (glyph && typeof glyph.unicode === 'string') text += glyph.unicode
    })

    if (text.trim()) parts.push(text.trim())
  })

  return parts.join(' ')
}

export const readPdfText = async (file, { restoreWordGaps = false } = {}) => {
  const pdfjs = await loadPdfjs()
  const data = await fileToUint8Array(file)
  const loadingTask = pdfjs.getDocument({ data })
  const pdf = await loadingTask.promise
  const textParts = []

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
    const page = await pdf.getPage(pageNumber)
    const content = await page.getTextContent()
    const pageText = content.items
      .map((item) => item.str || '')
      .join(' ')
      .trim()

    // Страницы без текстового слоя (сканы) не гоняем через список операторов
    if (!pageText) continue

    if (restoreWordGaps) {
      textParts.push(await readPageTextFromOperators(pdfjs, page) || pageText)
    } else {
      textParts.push(pageText)
    }
  }

  return textParts.join('\n\n')
}
